import * as React from "react";

import * as constants from "@client/constants";
import {Icon as IconLiterals} from "@client/constants";

import {Tab} from "@client/components/Tab";
import {Locator} from "@client/gotterdammerung";
import {classNames} from "@reactivated";

const styles = {
    selected: "bg-[#999999]",
    tabBar: "flex",
} as const;

export interface TabItem {
    title: string;
    link: (() => void) | Locator;
    icon: IconLiterals;
    isSelected: boolean;
    hasErrors: boolean;
}

interface Props {
    tabs: (TabItem | null)[];
    showSingleTab?: true;
}

export const TabBar = ({tabs, showSingleTab}: Props) => {
    const visibleTabs = tabs.filter((t) => t != null);
    const showIcon = visibleTabs.length <= constants.MAX_TABS_WITH_ICONS;
    const primaryIsSelected = visibleTabs[0]?.isSelected === true;

    if (visibleTabs.length <= 1 && showSingleTab !== true) {
        return null;
    }

    return (
        <>
            <ul className={classNames("tabBar", styles.tabBar)}>
                {visibleTabs.map((tab, index) => (
                    <Tab
                        key={index}
                        primaryIsSelected={primaryIsSelected}
                        showIcon={showIcon}
                        {...tab}
                    />
                ))}
            </ul>
        </>
    );
};
